/* Same Skies gift builder - every tap answers (2 Nov 2026).
   Clarity on paid phone traffic showed taps that did nothing: the dim area around the
   "Keep choosing" prompt, Continue on an empty box, the empty slots in the bottom rail and
   the example box photo. "Keep choosing" also just closed, leaving a half-filled box with no
   next step, and a box trimmed on review sat at "5 of 6" with no way to add one back there.
   Builder state comes from window.gbX, which sections/gift-builder.liquid exposes. */
(function () {
  var X = window.gbX;
  if (!X) return;

  var css = document.createElement('style');
  css.textContent =
    '.gb-bar-continue:disabled{pointer-events:none}' +
    '#gb-bar-slots .gb-bar-slot,#gb-e2-hero,#gb-step-4 .gb-review-cell-img{cursor:pointer}' +
    '.ss-gb-added #gb-step-4 .gb-review-cell-img{cursor:default}' +
    '.gb-ta-flash{animation:gbTaFlash .55s ease 2}' +
    '@keyframes gbTaFlash{0%,100%{box-shadow:0 0 0 0 rgba(168,94,56,0)}50%{box-shadow:0 0 0 4px rgba(168,94,56,.6)}}' +
    '.gb-ta-add{border:0;padding:0;background:none;font:inherit;text-align:left;cursor:pointer}' +
    '#gb-step-4 .gb-ta-add .gb-review-cell-img{box-sizing:border-box;border:1.5px dashed #c9b9a6;background:#faf6f0}' +
    '.gb-ta-plus{width:100%;aspect-ratio:1/1;display:flex;align-items:center;justify-content:center;color:#a85e38;font:300 30px/1 "DM Sans",sans-serif}';
  document.head.appendChild(css);

  function tier() { return X.st.boxTier && X.tiers[X.st.boxTier]; }
  function left() { var t = tier(); return t ? t.limit - Object.keys(X.st.byoItems).length : 0; }
  function locked() { return document.documentElement.classList.contains('ss-gb-added'); }
  function inside(el, e) {
    var r = el.getBoundingClientRect();
    return e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
  }
  function flash(el) {
    if (!el) return;
    el.classList.remove('gb-ta-flash');
    void el.offsetWidth;
    el.classList.add('gb-ta-flash');
    setTimeout(function () { el.classList.remove('gb-ta-flash'); }, 1200);
  }
  function showAll() {
    var all = document.querySelector('.gb-cat-tab');
    if (all && !all.classList.contains('active')) all.click();
  }
  function reveal(card) {
    if (!card.offsetParent) showAll();
    card.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(function () { flash(card); }, 350);
  }

  // Point at the next piece: an open card already on screen, else scroll to the first one.
  function guide(msg) {
    if (X.st.step !== 1 || !tier()) return;
    var n = left();
    var bar = document.getElementById('gb-bottom-bar');
    var barTop = bar ? bar.getBoundingClientRect().top : 0;
    var floor = barTop > 0 && barTop < window.innerHeight ? barTop : window.innerHeight;
    var open = [].filter.call(document.querySelectorAll('.gb-product-card'), function (c) {
      return c.offsetParent && !c.classList.contains('selected') && !c.classList.contains('gb-oos') && !c.classList.contains('gb-mix-limited');
    });
    var target = null;
    for (var i = 0; i < open.length && !target; i++) {
      var r = open[i].getBoundingClientRect();
      if (r.top >= 0 && r.bottom <= floor) target = open[i];
    }
    if (!target && open[0]) {
      target = open[0];
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    if (target) setTimeout(function () { flash(target); }, 350);
    [].forEach.call(document.querySelectorAll('#gb-bar-slots .gb-bar-slot:not(.is-filled)'), flash);
    if (msg || n > 0) X.toast(msg || (n === 1 ? '1 more piece to choose.' : n + ' more pieces to choose.') + ' Tap a photo to see it, or + to add it.');
  }

  // "Keep choosing", a tap on the dim area around the prompt, or Esc all mean the same thing.
  var dlg = document.getElementById('gb-underfill');
  if (dlg) {
    var keep = document.getElementById('gb-underfill-choose');
    if (keep) keep.addEventListener('click', function () { setTimeout(guide, 60); });
    dlg.addEventListener('click', function (e) {
      if (e.target !== dlg || inside(dlg, e)) return;
      dlg.close();
      setTimeout(guide, 60);
    });
    dlg.addEventListener('cancel', function () { setTimeout(guide, 60); });
  }

  // Continue on an empty box is disabled, which swallowed the tap. Let it fall through to the bar.
  var bottom = document.getElementById('gb-bottom-bar');
  if (bottom) bottom.addEventListener('click', function (e) {
    var b = bottom.querySelector('.gb-bar-continue');
    if (!b || !b.disabled || !inside(b, e)) return;
    if (!tier()) { X.toast('Choose a box first, then add your items.'); return; }
    guide('Tap any photo to add your first piece.');
  });

  // Slot rail: an empty slot points at what to add, a filled one jumps to its card.
  var rail = document.getElementById('gb-bar-slots');
  if (rail) rail.addEventListener('click', function (e) {
    var slot = e.target.closest('.gb-bar-slot');
    if (!slot) return;
    if (!slot.classList.contains('is-filled')) { guide(); return; }
    var id = Object.keys(X.st.byoItems)[[].indexOf.call(rail.children, slot)];
    var card = id && document.querySelector('.gb-product-card[data-id="' + id + '"]');
    if (card) reveal(card);
  });

  // The example box photo on step 1 does what the button under it does.
  var hero = document.getElementById('gb-e2-hero');
  var cta = document.getElementById('gb-e2-cta');
  if (hero && cta) hero.addEventListener('click', function () { cta.click(); });

  // Review: one tile per missing piece slot back to the grid; a photo goes back to its card.
  function backToBuild(then) {
    if (typeof window.gbGoStep !== 'function') return;
    window.gbGoStep(1, true);
    setTimeout(then, 80);
  }
  function addTile() {
    var grid = document.querySelector('#gb-step-4 .gb-review-grid');
    var n = left();
    if (!grid || locked() || n < 1 || grid.querySelector('.gb-ta-add')) return;
    var add = document.createElement('button');
    add.type = 'button';
    add.className = 'gb-review-cell gb-ta-add';
    add.setAttribute('aria-label', 'Add ' + n + ' more piece' + (n === 1 ? '' : 's') + ' to the box');
    add.innerHTML = '<span class="gb-review-cell-img" aria-hidden="true"><span class="gb-ta-plus">+</span></span><span class="gb-review-cell-cap"><b>Add ' + n + ' more</b><i>Same box price</i></span>';
    add.addEventListener('click', function () { backToBuild(guide); });
    grid.appendChild(add);
    grid.style.setProperty('--gb-review-cols', grid.children.length);
  }
  document.addEventListener('gb:review', addTile);
  addTile(); // a restored box can open on review before this deferred script runs
  // gb-review-v3.css pins review cells with !important, so drop the tile once the box is in the cart.
  new MutationObserver(function () {
    var tile = locked() && document.querySelector('.gb-ta-add');
    if (tile) tile.parentNode.removeChild(tile);
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  var review = document.getElementById('gb-step-4');
  if (review) review.addEventListener('click', function (e) {
    var img = e.target.closest('.gb-review-cell-img');
    var cell = img && img.closest('.gb-review-cell');
    if (!cell || !cell.dataset.id || locked()) return;
    var card = document.querySelector('.gb-product-card[data-id="' + cell.dataset.id + '"]');
    if (card) backToBuild(function () { reveal(card); });
  });

  // Tapping a picked card takes it out straight away. Offer it back.
  document.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest('.gb-product-card');
    if (!card || !card.classList.contains('selected') || e.target.closest('.gb-swatch')) return;
    setTimeout(function () {
      if (card.classList.contains('selected') || X.st.step !== 1) return;
      X.undoToast('Removed ' + (card.dataset.name || 'that piece') + '.', 'Undo', function () {
        if (!card.classList.contains('selected') && typeof window.gbQuickAdd === 'function') window.gbQuickAdd(card);
      }, { compact: true, ms: 4000 });
    }, 0);
  }, true);
})();
